export const API_URL = "https://api.synetrik.com";
// export const API_URL = "http://localhost:1337"

export const TOKEN_KEY = "strapi-jwt-token";
